//Material imports
import makeStyles from "@mui/styles/makeStyles";
export const verifySignUpScreenStyles = makeStyles(theme => ({
  inputField: {
    width: 45,
    background: theme.palette.background.default,
    marginRight: 16
  },
  childWrapper: {
    justifyContent: "center"
  },
  [theme.breakpoints.up("md")]: {
    childWrapper: {
      justifyContent: "flex-start"
    }
  }
}));